import type { AnomalySeries, DynamicFlatNode, IChannel } from 'commons';

/**
 * Action dispatched when anomalies are successfully retrieved.
 */
export class GetAnomaliesSUCCESS {
  static readonly type = '[Anomalies] getAnomaliesSUCCESS';

  /**
   * Constructor for GetAnomaliesSUCCESS.
   * @param anomalies - The list of retrieved anomaly series.
   */
  constructor(public anomalies: AnomalySeries[]) {}
}

/**
 * Action dispatched when retrieving anomalies fails.
 */
export class GetAnomaliesFAILURE {
  static readonly type = '[Anomalies] getAnomaliesFAILURE';
}

/**
 * Action to retrieve anomalies for a specific channel.
 */
export class GetAnomaliesByChannel {
  static readonly type = '[Anomalies] getAnomalies]';

  /**
   * Constructor for GetAnomaliesByChannel.
   * @param node - The dynamic flat node representing the channel.
   */
  constructor(public readonly node: DynamicFlatNode<IChannel>) {}
}
